// extracted by mini-css-extract-plugin
export default {"banner":"TrialExpirationBanner_banner__E3W9j","renewButton":"TrialExpirationBanner_renewButton__ohPku"};